module.exports = __webpack_public_path__ + "fonts/411ddc1fae299bb1f0f5408551edf975.svg";